import { getSignAndFooter } from "./EmailTemplates";
import { EmailTemplates } from "./LoanData";

export enum EmailTemplates2 {
  LOAN_SUBMITTED_FOR_REVIEW_BY_BORROWER = 'LOAN_SUBMITTED_FOR_REVIEW_BY_BORROWER',
  LOAN_SUBMITTED_FOR_REVIEW_BY_BROKER = 'LOAN_SUBMITTED_FOR_REVIEW_BY_BROKER',
  LOAN_SUBMITTED_FOR_REVIEW_BY_BORROWER_VIA_BROKER = 'LOAN_SUBMITTED_FOR_REVIEW_BY_BORROWER_VIA_BROKER',
  INVITE_BORROWER_LOAN_OFFICER = 'INVITE_BORROWER_LOAN_OFFICER',
  INVITE_BROKER_LOAN_OFFICER = 'INVITE_BROKER_LOAN_OFFICER',
  LOAN_OFFICER_ASSIGNED_TO_LOAN = 'LOAN_OFFICER_ASSIGNED_TO_LOAN',
  // Sent by staff/broker from Next Steps to route the signer into the embedded e-sign portal.
  MAIN_GUARANTOR_ESIGN_PORTAL_LINK = 'MAIN_GUARANTOR_ESIGN_PORTAL_LINK',
  THIRD_PARTY_REPORT_STATUS_UPDATED_TO_CLIENT = 'THIRD_PARTY_REPORT_STATUS_UPDATED_TO_CLIENT',
  NEXT_STEPS_STATUS_UPDATED_TO_CLIENT = 'NEXT_STEPS_STATUS_UPDATED_TO_CLIENT',
  BROKER_ONLY_DOCUMENT_UPLOADED_TO_STAFF = 'BROKER_ONLY_DOCUMENT_UPLOADED_TO_STAFF',
  APPLICATION_DECLINED_BORROWER_NOTIFICATION = 'APPLICATION_DECLINED_BORROWER_NOTIFICATION',
  LOAN_APPLICATION_CANCELLED_TO_STAFF = 'LOAN_APPLICATION_CANCELLED_TO_STAFF',
  LOAN_TERMS_UPDATED_AVAILABLE_TO_CLIENT = 'LOAN_TERMS_UPDATED_AVAILABLE_TO_CLIENT',
  LOAN_STAGE_UPDATED_TO_CLIENT_PREQUALIFICATION = 'LOAN_STAGE_UPDATED_TO_CLIENT_PREQUALIFICATION',
  LOAN_STAGE_UPDATED_TO_CLIENT_PROCESSING = 'LOAN_STAGE_UPDATED_TO_CLIENT_PROCESSING',
  LOAN_STAGE_UPDATED_TO_CLIENT_UNDERWRITING = 'LOAN_STAGE_UPDATED_TO_CLIENT_UNDERWRITING',
  LOAN_STAGE_UPDATED_TO_CLIENT_CLOSING = 'LOAN_STAGE_UPDATED_TO_CLIENT_CLOSING',
  LOGIN_LINK_NEW_USER = 'LOGIN_LINK_NEW_USER',
  LOGIN_LINK_EXISTING_USER = 'LOGIN_LINK_EXISTING_USER',
  EMAIL_CHANGE_VERIFICATION = 'EMAIL_CHANGE_VERIFICATION',
  EMAIL_CHANGE_NOTIFICATION = 'EMAIL_CHANGE_NOTIFICATION',
  PREQUAL_BORROWER = 'PREQUAL_BORROWER',
  PREQUAL_BROKER = 'PREQUAL_BROKER',
  PREQUAL_STAFF = 'PREQUAL_STAFF',
}

export enum EmailIds {
  NO_REPLY_EMAIL  = 'noreply@stormfieldcapital.com',
  LOANS_EMAIL     = 'Stormfield Capital <loans@stormfieldcapital.com>',
}

export function getEmailSubjectAndBody(emailTemplate: string, data: { [key: string]: string } = {}): { subject: string; bodyHtml: string } {
  switch (emailTemplate) {
    case EmailTemplates.STAFF_WELCOME:
      return staffWelcomeEmail(data);
    case EmailTemplates.PORTAL_INVITE:
      return portalInviteEmail(data);
    case EmailTemplates.PQ_QUALIFIED:
      return preQualificationEmail(data);
    default:
      return { subject: '', bodyHtml: '' };
  }
}

function staffWelcomeEmail(data: { [key: string]: string }): { subject: string; bodyHtml: string } {
  const firstName = data.firstName || 'there';
  const portalUrl = data.portalUrl;
  const roles = data.roles || '';
  const assignedBy = data.assignedBy || '';

  return {
    subject: 'Welcome to Stormfield Capital Portal',
    bodyHtml: `
      <div style="font-family: Arial, sans-serif; max-width: 700px; margin: 0 auto; background-color: #ffffff;">
        <!-- Main Content -->
        <div style="padding: 40px 30px; background-color: #ffffff;">
          <h2 style="color: #1f2937; margin: 0 0 24px 0; font-weight: 600;">
            Welcome to Stormfield Capital
          </h2>
          
          <p style="color: #4b5563; line-height: 1.6; margin: 0 0 20px 0;">
            Hello ${firstName},
          </p>
          
          <p style="color: #4b5563; line-height: 1.6; margin: 0 0 20px 0;">
            ${assignedBy ? `${assignedBy} has added you` : 'You have been added'} to the Stormfield Capital Portal${roles ? ` with the following role(s): <strong>${roles}</strong>` : ''}.
          </p>
          
          <p style="color: #4b5563; line-height: 1.6; margin: 0 0 2px 0;">
            Click the button below to access your portal.
          </p>
          
          <!-- CTA Button -->
          ${getCtaButton({
            label: 'Go to Portal',
            url: portalUrl,
          })}
          
          <!-- Alternative Link -->
          <div style="background-color: #f9fafb; border: 1px solid #e5e7eb; padding: 20px; margin: 10px 0;">
            <p style="color: #6b7280; margin: 0 0 8px 0;">
              If the button above doesn't work, copy and paste this link into your browser:
            </p>
            <a href="${portalUrl}" style="word-break: break-all; font-size: 13px; font-family: 'Courier New', monospace; background-color: #ffffff; padding: 8px; margin: 0; display: block;">
              ${portalUrl}
            </a>
          </div>
          
          <!-- Footer -->
          <div style="text-align: center;">
            <p style="color: #9ca3af; font-size: 12px; margin: 0 0 2px 0;">
              If you have any questions, please reach out to your manager or the admin team.
            </p>
          </div>
        </div>
      </div>
      ${getSignAndFooter()}`,
  };
}

function portalInviteEmail(data: { [key: string]: string }): { subject: string; bodyHtml: string } {
  const firstName = data.firstName || 'there';
  const portalUrl = data.portalUrl;
  const roles = data.roles || '';
  const assignedBy = data.assignedBy || '';

  return {
    subject: 'You’re Invited to Stormfield Capital Portal',
    bodyHtml: `
      <div style="font-family: Arial, sans-serif; max-width: 700px; margin: 0 auto; background-color: #ffffff;">
        <div style="padding: 40px 30px; background-color: #ffffff;">
          <h2 style="color: #1f2937; margin: 0 0 24px 0; font-weight: 600;">
            Welcome to Stormfield Capital
          </h2>
          
          <p style="color: #4b5563; line-height: 1.6; margin: 0 0 20px 0;">
            Hello ${firstName},
          </p>
          
          <p style="color: #4b5563; line-height: 1.6; margin: 0 0 20px 0;">
            ${assignedBy ? `${assignedBy} has invited you` : 'You have been invited'} to the Stormfield Capital Portal${roles ? ` with the following role(s): <strong>${roles}</strong>` : ''}.
          </p>
          
          <p style="color: #4b5563; line-height: 1.6; margin: 0 0 2px 0;">
            Click the button below to access your portal.
          </p>
          
          ${getCtaButton({
            label: 'Go to Portal',
            url: portalUrl,
          })}
          
          <div style="background-color: #f9fafb; border: 1px solid #e5e7eb; padding: 20px; margin: 10px 0;">
            <p style="color: #6b7280; margin: 0 0 8px 0;">
              If the button above doesn't work, copy and paste this link into your browser:
            </p>
            <a href="${portalUrl}" style="word-break: break-all; font-size: 13px; font-family: 'Courier New', monospace; background-color: #ffffff; padding: 8px; margin: 0; display: block;">
              ${portalUrl}
            </a>
          </div>
        </div>
      </div>
      ${getSignAndFooter()}`,
  };
}

function preQualificationEmail(data: { [key: string]: string }): { subject: string; bodyHtml: string } {
  const propertyAddress = data.propertyAddress || '';
  const firstName = data.firstName || 'there';
  const url = data.url || '';

  return {
    subject: `Your Pre-Qualification Estimate for ${propertyAddress}`,
    bodyHtml: `
      <p>Hi ${firstName},</p>

      <p>You requested a pre-qualification estimate for your loan. Attached is your current set of proposed terms.</p>

      <p>If everything looks good, you can continue your application directly from your loan dashboard:</p>

      ${getSignInButton(url)} 

      <p>If you have questions, feel free to reach out.</p>

      ${getSignAndFooter()}`,
  };
}


function getCtaButton({
  label,
  url,
}: {
  label: string;
  url: string;
}): string {
  return `
      <div style="text-align: left; margin: 20px 0;">
        <a href="${url}" style="background-color: rgb(44, 74, 93); border: 1px solid rgb(44, 74, 93); border-radius: 6px; color: #ffffff; padding: 10px 18px; text-decoration: none; display: inline-block; font-size: 14px; font-weight: 500; line-height: 1.2;">
          ${label}
        </a>
      </div>`;
}

function getSignInButton(url: string): string {
  return getCtaButton({label: 'Sign In', url,});
}
